export const routes = {
    sms: {
        request: "/sms/request",
        confirm: "/sms/confirm",
    },
    acnt: {
        request: "/acnt/request",
        confirm: "/acnt/confirm",
    },
    agree: {
        page: "/agree/page",
    }
}





